import type { ApDemoAudit, ApDemoCase } from '../../lib/api-client';
import { Badge } from '../ui/Badge';

function tone(status: string): 'success' | 'warning' | 'destructive' | 'secondary' {
  if (status === 'IN_PAYMENT_PROPOSAL' || status === 'COMPLETED') return 'success';
  if (status === 'AWAITING_APPROVAL' || status === 'ON_HOLD') return 'warning';
  if (status === 'EXCEPTION' || status === 'REJECTED') return 'destructive';
  return 'secondary';
}

export function ApCasePack({ caseRow, audit }: { caseRow: ApDemoCase | null; audit: ApDemoAudit[] }) {
  if (!caseRow) return null;
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-900" data-testid="ap-case-pack">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <h3 className="text-lg font-semibold">
            {caseRow.invoice_number} · {caseRow.case_id}
          </h3>
          <p className="text-sm text-gray-500">
            {caseRow.phase_label} · {caseRow.vendor_name}
          </p>
        </div>
        <Badge variant={tone(caseRow.status)}>{caseRow.status}</Badge>
      </div>
      <dl className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1 text-sm sm:grid-cols-4">
        <dt className="text-gray-400">Amount</dt>
        <dd>
          {caseRow.gross_total} {caseRow.currency}
        </dd>
        <dt className="text-gray-400">PO</dt>
        <dd>{caseRow.po_number || 'none'}</dd>
        <dt className="text-gray-400">IBAN</dt>
        <dd className="truncate">{caseRow.iban}</dd>
        <dt className="text-gray-400">Role</dt>
        <dd>{caseRow.approver_role || 'none'}</dd>
      </dl>
      <p className="mt-3 text-sm">{caseRow.explanation}</p>
      {caseRow.reason_codes.length > 0 && (
        <p className="mt-1 text-xs text-amber-600">Reasons: {caseRow.reason_codes.join(', ')}</p>
      )}
      {audit.length > 0 && (
        <>
          <h4 className="mt-4 text-sm font-semibold">History and reasoning</h4>
          <ul className="mt-2 space-y-2 text-sm" data-testid="ap-case-audit">
            {audit.map((entry) => (
              <li key={`${entry.timestamp}-${entry.action}`}>
                <div className="text-[0.65rem] uppercase text-gray-400">
                  {entry.timestamp} · {entry.step} · {entry.actor_id}
                </div>
                <div>
                  {entry.action}: {entry.decision}
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
      <p className="mt-3 text-xs text-gray-400">Illustrative mock. Synthetic Hisense Europe CFSSC data. No live SAP or bank.</p>
    </div>
  );
}
